// Mock data for Ca' del Sole Italia

export const translations = {
  it: {
    nav: {
      home: 'Home',
      casa: 'Casa Vacanze',
      eventi: 'Eventi Privati',
      galleria: 'Galleria',
      location: 'Dove Siamo',
      contatti: 'Contatti'
    },
    hero: {
      title: 'Ca\' del Sole Italia',
      subtitle: 'Nel cuore del Borgo Medievale di Montagnana (PD)',
      description: 'Un\' esperienza esclusiva dove storia e intimità si incontrano',
      cta: 'Scopri di più'
    },
    casa: {
      title: 'La Casa',
      subtitle: 'Un rifugio romantico per due',
      description: 'Ca\' del Sole Italia è pensata per coppie che cercano un\' esperienza autentica nel cuore del borgo medievale di Montagnana. Ogni dettaglio è curato per offrire comfort, eleganza e momenti indimenticabili, tra cui la nostra esclusiva Jacuzzi per due, perfetta per rilassarvi sotto le stelle.',
      features: [
        {
          title: 'Sorprese Quotidiane',
          description: 'Ogni giorno i nostri ospiti ricevono pensierini e sorprese che rendono il soggiorno unico e memorabile'
        },
        {
          title: 'Posizione Esclusiva',
          description: 'All\'interno del borgo medievale, affacciata sulle mura antiche e circondata dai tesori di Montagnana'
        },
        {
          title: 'Esperienza Autentica',
          description: 'Vivi la vera essenza italiana in un ambiente raffinato che unisce tradizione e modernità'
        }
      ]
    },
    eventi: {
      title: 'Eventi Privati',
      subtitle: 'Momenti speciali fino a 10 ospiti',
      description: 'Ca\' del Sole Italia è la location perfetta per eventi intimi ed eleganti. Mettiamo a disposizione lo spazio, voi portate la celebrazione.',
      types: [
        {
          title: 'Proposte di Matrimonio',
          description: 'Crea il momento perfetto in un\' ambientazione romantica e indimenticabile'
        },
        {
          title: 'Cene tra Amici',
          description: 'Ospita i tuoi cari in un ambiente elegante e riservato'
        },
        {
          title: 'Anniversari',
          description: 'Celebra momenti speciali con chi ami in totale privacy'
        },
        {
          title: 'Eventi Aziendali',
          description: 'Meeting esclusivi in un contesto unico e stimolante'
        }
      ],
      note: 'Location rental: organizzate il vostro catering o chef privato, noi offriamo lo spazio perfetto'
    },
    location: {
      title: 'Dove Siamo',
      subtitle: 'Borgo Medievale di Montagnana',
      address: 'Via Mure Sud 8, Montagnana (PD), Italia',
      description: 'Nel cuore delle mura medievali meglio conservate d\'Europa, Montagnana vi aspetta con la sua storia millenaria, i suoi tesori artistici e la sua autenticità.',
      addressLabel: 'Indirizzo',
      quote: 'Un luogo dove la storia medievale incontra il comfort moderno, nel cuore di uno dei borghi più belli d\'Italia.'
    },
    contact: {
      title: 'Contattaci',
      subtitle: 'Richiedi informazioni',
      phoneLabel: 'Chiamaci',
      whatsappCta: 'Scrivici su WhatsApp per una risposta immediata',
      form: {
        name: 'Nome',
        email: 'Email',
        phone: 'Telefono',
        message: 'Messaggio',
        submit: 'Invia Richiesta'
      },
      social: 'Seguici sui social'
    },
    footer: {
      tagline: 'Dove ogni momento diventa un ricordo prezioso',
      rights: '© 2025 Ca\' del Sole Italia. Tutti i diritti riservati.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      casa: 'Vacation Home',
      eventi: 'Private Events',
      galleria: 'Gallery',
      location: 'Location',
      contatti: 'Contact'
    },
    hero: {
      title: 'Ca\' del Sole Italia',
      subtitle: 'In the heart of Montagnana (PD)\'s Medieval Village',
      description: 'An exclusive experience where history and intimacy meet',
      cta: 'Discover More'
    },
    casa: {
      title: 'The House',
      subtitle: 'A romantic retreat for two',
      description: 'Ca\' del Sole Italia is designed for couples seeking an authentic experience in the heart of Montagnana\'s medieval village. Every detail is crafted to offer comfort, elegance, and unforgettable moments, including our exclusive Jacuzzi for two, perfect for relaxing under the stars.',
      features: [
        {
          title: 'Daily Surprises',
          description: 'Every day our guests receive thoughtful gifts and surprises that make their stay unique and memorable'
        },
        {
          title: 'Exclusive Location',
          description: 'Inside the medieval borgo, overlooking the ancient walls and surrounded by Montagnana\'s treasures'
        },
        {
          title: 'Authentic Experience',
          description: 'Live the true Italian essence in a refined atmosphere that blends tradition and modernity'
        }
      ]
    },
    eventi: {
      title: 'Private Events',
      subtitle: 'Special moments for up to 10 guests',
      description: 'Ca\' del Sole Italia is the perfect venue for intimate and elegant events. We provide the space, you bring the celebration.',
      types: [
        {
          title: 'Marriage Proposals',
          description: 'Create the perfect moment in a romantic and unforgettable setting'
        },
        {
          title: 'Dinners with Friends',
          description: 'Host your loved ones in an elegant and private atmosphere'
        },
        {
          title: 'Anniversaries',
          description: 'Celebrate special moments with those you love in complete privacy'
        },
        {
          title: 'Corporate Events',
          description: 'Exclusive meetings in a unique and inspiring context'
        }
      ],
      note: 'Location rental: arrange your own catering or private chef, we provide the perfect space'
    },
    location: {
      title: 'Where We Are',
      subtitle: 'Medieval Village of Montagnana',
      address: 'Via Mure Sud 8, Montagnana (PD), Italy',
      description: 'In the heart of Europe\'s best-preserved medieval walls, Montagnana awaits you with its thousand-year history, artistic treasures, and authenticity.',
      addressLabel: 'Address',
      quote: 'A place where medieval history meets modern comfort, in the heart of one of Italy\'s most beautiful villages.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Request Information',
      phoneLabel: 'Call Us',
      whatsappCta: 'Message us on WhatsApp for an immediate response',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send Request'
      },
      social: 'Follow us on social media'
    },
    footer: {
      tagline: 'Where every moment becomes a precious memory',
      rights: '© 2025 Ca\' del Sole Italia. All rights reserved.'
    }
  },
  de: {
    nav: {
      home: 'Startseite',
      casa: 'Ferienhaus',
      eventi: 'Private Events',
      galleria: 'Galerie',
      location: 'Standort',
      contatti: 'Kontakt'
    },
    hero: {
      title: 'Ca\' del Sole Italia',
      subtitle: 'Im Herzen des mittelalterlichen Dorfes Montagnana (PD)',
      description: 'Ein exklusives Erlebnis, wo Geschichte und Intimität sich treffen',
      cta: 'Mehr erfahren'
    },
    casa: {
      title: 'Das Haus',
      subtitle: 'Ein romantischer Rückzugsort für zwei',
      description: 'Ca\' del Sole Italia ist für Paare konzipiert, die ein authentisches Erlebnis im Herzen des mittelalterlichen Dorfes Montagnana suchen. Jedes Detail ist sorgfältig gestaltet, um Komfort, Eleganz und unvergessliche Momente zu bieten, darunter unser exklusiver Whirlpool für zwei, perfekt zum Entspannen unter den Sternen.',
      features: [
        {
          title: 'Tägliche Überraschungen',
          description: 'Jeden Tag erhalten unsere Gäste liebevolle Geschenke und Überraschungen, die ihren Aufenthalt einzigartig und unvergesslich machen'
        },
        {
          title: 'Exklusive Lage',
          description: 'Im mittelalterlichen Borgo, mit Blick auf die antiken Mauern und umgeben von den Schätzen Montagnanasumgeben'
        },
        {
          title: 'Authentisches Erlebnis',
          description: 'Erleben Sie die wahre italienische Essenz in einer raffinierten Atmosphäre, die Tradition und Moderne verbindet'
        }
      ]
    },
    eventi: {
      title: 'Private Events',
      subtitle: 'Besondere Momente für bis zu 10 Gäste',
      description: 'Ca\' del Sole Italia ist der perfekte Ort für intime und elegante Events. Wir stellen den Raum zur Verfügung, Sie bringen die Feier.',
      types: [
        {
          title: 'Heiratsanträge',
          description: 'Schaffen Sie den perfekten Moment in einer romantischen und unvergesslichen Umgebung'
        },
        {
          title: 'Abendessen mit Freunden',
          description: 'Empfangen Sie Ihre Liebsten in einer eleganten und privaten Atmosphäre'
        },
        {
          title: 'Jubiläen',
          description: 'Feiern Sie besondere Momente mit Ihren Liebsten in absoluter Privatsphäre'
        },
        {
          title: 'Firmenevents',
          description: 'Exklusive Meetings in einem einzigartigen und inspirierenden Kontext'
        }
      ],
      note: 'Location-Vermietung: Organisieren Sie Ihr eigenes Catering oder Privatkoch, wir bieten den perfekten Raum'
    },
    location: {
      title: 'Wo wir sind',
      subtitle: 'Mittelalterliches Dorf Montagnana',
      address: 'Via Mure Sud 8, Montagnana (PD), Italien',
      description: 'Im Herzen der am besten erhaltenen mittelalterlichen Mauern Europas erwartet Sie Montagnana mit seiner tausendjährigen Geschichte, künstlerischen Schätzen und Authentizität.',
      addressLabel: 'Adresse',
      quote: 'Ein Ort, an dem mittelalterliche Geschichte auf modernen Komfort trifft, im Herzen eines der schönsten Dörfer Italiens.'
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Informationen anfordern',
      phoneLabel: 'Rufen Sie uns an',
      whatsappCta: 'Schreiben Sie uns auf WhatsApp für eine sofortige Antwort',
      form: {
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        message: 'Nachricht',
        submit: 'Anfrage senden'
      },
      social: 'Folgen Sie uns auf Social Media'
    },
    footer: {
      tagline: 'Wo jeder Moment zu einer kostbaren Erinnerung wird',
      rights: '© 2025 Ca\' del Sole Italia. Alle Rechte vorbehalten.'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      casa: 'Maison de Vacances',
      eventi: 'Événements Privés',
      galleria: 'Galerie',
      location: 'Localisation',
      contatti: 'Contact'
    },
    hero: {
      title: 'Ca\' del Sole Italia',
      subtitle: 'Au cœur du village médiéval de Montagnana (PD)',
      description: 'Une expérience exclusive où histoire et intimité se rencontrent',
      cta: 'Découvrir plus'
    },
    casa: {
      title: 'La Maison',
      subtitle: 'Un refuge romantique pour deux',
      description: 'Ca\' del Sole Italia est conçue pour les couples à la recherche d\'une expérience authentique au cœur du village médiéval de Montagnana. Chaque détail est soigné pour offrir confort, élégance et moments inoubliables, notamment notre Jacuzzi exclusif pour deux, parfait pour se détendre sous les étoiles.',
      features: [
        {
          title: 'Surprises Quotidiennes',
          description: 'Chaque jour nos hôtes reçoivent des cadeaux et surprises qui rendent leur séjour unique et mémorable'
        },
        {
          title: 'Emplacement Exclusif',
          description: 'À l\'intérieur du borgo médiéval, avec vue sur les murs antiques et entouré des trésors de Montagnana'
        },
        {
          title: 'Expérience Authentique',
          description: 'Vivez la véritable essence italienne dans une atmosphère raffinée qui allie tradition et modernité'
        }
      ]
    },
    eventi: {
      title: 'Événements Privés',
      subtitle: 'Moments spéciaux jusqu\'à 10 invités',
      description: 'Ca\' del Sole Italia est le lieu parfait pour des événements intimes et élégants. Nous fournissons l\'espace, vous apportez la célébration.',
      types: [
        {
          title: 'Demandes en Mariage',
          description: 'Créez le moment parfait dans un cadre romantique et inoubliable'
        },
        {
          title: 'Dîners entre Amis',
          description: 'Accueillez vos proches dans une atmosphère élégante et privée'
        },
        {
          title: 'Anniversaires',
          description: 'Célébrez des moments spéciaux avec ceux que vous aimez en toute intimité'
        },
        {
          title: 'Événements d\'Entreprise',
          description: 'Réunions exclusives dans un contexte unique et inspirant'
        }
      ],
      note: 'Location d\'espace: organisez votre propre traiteur ou chef privé, nous offrons l\'espace parfait'
    },
    location: {
      title: 'Où Nous Sommes',
      subtitle: 'Village Médiéval de Montagnana',
      address: 'Via Mure Sud 8, Montagnana (PD), Italie',
      description: 'Au cœur des murs médiévaux les mieux conservés d\'Europe, Montagnana vous attend avec son histoire millénaire, ses trésors artistiques et son authenticité.',
      addressLabel: 'Adresse',
      quote: 'Un lieu où l\'histoire médiévale rencontre le confort moderne, au cœur de l\'un des plus beaux villages d\'Italie.'
    },
    contact: {
      title: 'Nous Contacter',
      subtitle: 'Demander des informations',
      phoneLabel: 'Appelez-nous',
      whatsappCta: 'Écrivez-nous sur WhatsApp pour une réponse immédiate',
      form: {
        name: 'Nom',
        email: 'E-mail',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Envoyer la demande'
      },
      social: 'Suivez-nous sur les réseaux sociaux'
    },
    footer: {
      tagline: 'Où chaque moment devient un souvenir précieux',
      rights: '© 2025 Ca\' del Sole Italia. Tous droits réservés.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      casa: 'Casa Vacacional',
      eventi: 'Eventos Privados',
      galleria: 'Galería',
      location: 'Ubicación',
      contatti: 'Contacto'
    },
    hero: {
      title: 'Ca\' del Sole Italia',
      subtitle: 'En el corazón del pueblo medieval de Montagnana (PD)',
      description: 'Una experiencia exclusiva donde la historia y la intimidad se encuentran',
      cta: 'Descubre más'
    },
    casa: {
      title: 'La Casa',
      subtitle: 'Un refugio romántico para dos',
      description: 'Ca\' del Sole Italia está pensada para parejas que buscan una experiencia auténtica en el corazón del pueblo medieval de Montagnana. Cada detalle está cuidado para ofrecer confort, elegancia y momentos inolvidables, incluyendo nuestro exclusivo Jacuzzi para dos, perfecto para relajarse bajo las estrellas.',
      features: [
        {
          title: 'Sorpresas Diarias',
          description: 'Cada día nuestros huéspedes reciben regalos y sorpresas que hacen su estancia única y memorable'
        },
        {
          title: 'Ubicación Exclusiva',
          description: 'Dentro del pueblo medieval, con vistas a las antiguas murallas y rodeada de los tesoros de Montagnana'
        },
        {
          title: 'Experiencia Auténtica',
          description: 'Vive la verdadera esencia italiana en un ambiente refinado que combina tradición y modernidad'
        }
      ]
    },
    eventi: {
      title: 'Eventos Privados',
      subtitle: 'Momentos especiales hasta 10 invitados',
      description: 'Ca\' del Sole Italia es el lugar perfecto para eventos íntimos y elegantes. Ofrecemos el espacio, vosotros aportáis la celebración.',
      types: [
        {
          title: 'Propuestas de Matrimonio',
          description: 'Crea el momento perfecto en un entorno romántico e inolvidable'
        },
        {
          title: 'Cenas entre Amigos',
          description: 'Acoge a tus seres queridos en un ambiente elegante y reservado'
        },
        {
          title: 'Aniversarios',
          description: 'Celebra momentos especiales con quien amas en total privacidad'
        },
        {
          title: 'Eventos Corporativos',
          description: 'Reuniones exclusivas en un contexto único e inspirador'
        }
      ],
      note: 'Alquiler de local: organizad vuestro propio catering o chef privado, nosotros ofrecemos el espacio perfecto'
    },
    location: {
      title: 'Dónde Estamos',
      subtitle: 'Pueblo Medieval de Montagnana',
      address: 'Via Mure Sud 8, Montagnana (PD), Italia',
      description: 'En el corazón de las murallas medievales mejor conservadas de Europa, Montagnana os espera con su historia milenaria, sus tesoros artísticos y su autenticidad.',
      addressLabel: 'Dirección',
      quote: 'Un lugar donde la historia medieval se encuentra con el confort moderno, en el corazón de uno de los pueblos más bellos de Italia.'
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Solicita información',
      phoneLabel: 'Llámanos',
      whatsappCta: 'Escríbenos por WhatsApp para una respuesta inmediata',
      form: {
        name: 'Nombre',
        email: 'Email',
        phone: 'Teléfono',
        message: 'Mensaje',
        submit: 'Enviar Solicitud'
      },
      social: 'Síguenos en redes sociales'
    },
    footer: {
      tagline: 'Donde cada momento se convierte en un recuerdo precioso',
      rights: '© 2025 Ca\' del Sole Italia. Todos los derechos reservados.'
    }
  }
};

export const images = {
  // Bicchiere di vino al tramonto con castello riflesso - hero atmosferico
  hero: 'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/9v7nca5h_IMG_2171.webp',
  // Coppia nella jacuzzi notturna - atmosfera romantica
  casa1: 'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/tuyhurua_IMG_0347.jpeg',
  // Cena romantica serale con candele
  casa2: 'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/hvnht955_IMG_1370.jpeg',
  // Coppia che cena con vista castello (giorno) - sezione eventi
  eventi: 'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/88wjaq8i_b62c9b19-edc1-4802-8441-20807d602882.jpeg',
  gallery: [
    // Nuova foto: terrazza con palma e mura castello
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/2grudlo4_d7fb8b51-ddac-4668-aee8-05f2907ff744.jpeg',
    // Jacuzzi notturna
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/tuyhurua_IMG_0347.jpeg',
    // Nuova foto: bicchiere di vino al tramonto
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/9v7nca5h_IMG_2171.webp',
    // Terrazza con jacuzzi diurna
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/gw5zj5a9_IMG_1369.jpeg',
    // Coppia cena serale (unica foto persone a tavola)
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/hvnht955_IMG_1370.jpeg',
    // Vista aerea del borgo con cuore (senza testo)
    'https://customer-assets-agu9un31.emergentagent.net/job_cadelsole-events/artifacts/qbc28fsl_00e8573b-d708-4fe9-a03d-fdb39258ca9b.webp'
  ]
};

export const socialLinks = {
  facebook: 'https://www.facebook.com/cadelsoleitalia',
  instagram: 'https://www.instagram.com/cadelsoleitalia',
  whatsapp: 'https://wa.me/393494651960',
  phone: '+39 349 465 1960',
  phoneLink: 'tel:+393494651960'
};
